import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EpayService } from 'src/app/services/epay.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-epay-payment',
  templateUrl: './epay-payment.component.html',
  styleUrls: ['./epay-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EPayPaymentComponent {
  response: string | null = null;
  error:string | null = null;

  constructor(private epayService: EpayService,private cd:ChangeDetectorRef) { }

  submitPayment(form: NgForm): void {
    const data = {
      MIN: environment.easyPayMurchId, // Заменете с реален клиентски идентификационен номер
      //EMAIL: 'a@merch.bg', // Заменете с реален email на търговеца
      INVOICE: form.value.invoice,
      AMOUNT: form.value.amount,
      CURRENCY: 'BGN', // Валутата е фиксирана, можете да направите това поле също динамично
      EXP_TIME: form.value.exp_time,
      DESCR: 'Test', // Можете да добавите това поле във формата, ако искате
      ENCODING: 'utf-8'
    };

    const encoded = this.epayService.encodeData(data);
    const checksum = this.epayService.generateChecksum(encoded);

    this.epayService.requestPayment(encoded, checksum).subscribe(
      response => {

        if (response.indexOf('IDN') > -1) {
          this.response = response.replace('IDN=', '');
          this.error = '';
        }
        else {
          this.error = response;
        }

        this.cd.detectChanges();
        console.log('Response received:', response);
      },
      (error: HttpErrorResponse) => {
        console.error('Error received:', error);
        if (error.status === 200) {
          // Може би е полезно да логнеш и съдържанието на отговора
          console.log('Response body:', error.error);
        }
      }
    );

  }
}
